import React from "react";
import PropTypes from "prop-types";
import { i18n } from "@euroland/libs";
import { classNames, replaceKey } from "../../utils";
import { formatDate } from "@euroland/libs";
import { DATE_SCREEN_READER } from "../../constant/common";

const CheckedIcon = () => (
  <svg
    className="radio-check-icon"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="18" height="18" rx="1.5" />
    <path d="M4 9.29412L7.80769 13L15 6" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const UncheckIcon = () => (
  <svg
    className="radio-uncheck-icon"
    stroke="#979797"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="18" height="18" rx="1.5" />
  </svg>
);

export default function Ratio({ checked, label, onClick, idTicker, ...props }) {
  return (
    <div
      className={classNames("Ratio", { checked })}
      onClick={onClick}
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      id-ticker={idTicker}
    >
      <div className="Ratio__icon">{checked ? <CheckedIcon /> : <UncheckIcon />}</div>
      <div className="Ratio__content">
        <p className="Ratio__label">{label}</p>
        <div
          className="Ratio__date"
          role="note"
          aria-label={
            !props.startingDate
              ? i18n.translate("textNoData")
              : formatDate(props.startingDate, "", DATE_SCREEN_READER)
          }
        >
          {replaceKey(i18n.translate("startingDateTickerQuadrata"), [
            !props.startingDate ? i18n.translate("textNoData") : formatDate(props.startingDate, "longDate"),
          ])}
        </div>
      </div>
    </div>
  );
}

Ratio.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.element,
  idTicker: PropTypes.number,
  onClick: PropTypes.func,
};
